<template>
  <div class="main-content">
    <md-tabs
      class="md-primary"
      md-centered
      md-elevation="1"
      @change="onAreaChangeDelegate"
      :md-dynamic-height="true"
    >
      <md-tab
        v-for="(area, key) in certificationProcess.areas"
        :key="key"
        :id="`tab-${key}`"
        :md-label="area.name"
        :md-active="key === currPhotoArea"
      >
        <!-- <md-layout
          md-column
          v-if="area.status === 2"
        >
          <span class="md-title">{{ area.name }} - {{ structures.length + vertices.length }} objetos
            de análise foram submetidos.
          </span>
          <p> FOTOS DA ÁREA SINCRONIZADAS COM SUCESSO!</p>
          <span class="caption">Após a sincronização não é possível adicionar ou alterar as fotos da área.</span>
        </md-layout> -->
        <div md-column>
          <md-layout md-column>
          <span class="md-title">{{ area.name }}
          </span>
<span class="caption" v-if="area.description && area.description.trim().length > 0"
          ><b>Informações adicionais:</b> {{area.description}}.</span
          >
          <span class="caption"
          >Adicione as fotos de acordo com os items abaixo.</span
          >
          </md-layout>
          <md-list>
            <md-subheader class="md-primary">
              VÉRTICES&nbsp;
              <span class="md-caption"
            > **<b>Vértices</b> são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo.<br /></span
          >
              </md-subheader>
            <md-list-item
              v-for="(vertice, index) in area.vertices"
              :key="`vertice${index}`"
              @click="addPhotos(index, vertice.type)"
            >
              <div class="md-list-text-container">
                <span>{{ vertice.name }}</span>
                <p>{{ vertice.description }}</p>
              </div>

              <md-button class="md-icon-button md-list-action">
                <md-icon
                  class="done"
                  v-if="vertice.status === 1"
                >done</md-icon>
                <md-icon v-else>add_a_photo</md-icon>
              </md-button>

              <md-divider class="md-inset"></md-divider>
            </md-list-item>
            <md-subheader
              v-if="area.structures"
              class="md-primary"
            >EQUIPAMENTOS</md-subheader>
            <md-list-item
              v-for="(structure, index) in area.structures"
              :key="`structure${index}`"
              @click="addPhotos(index, structure.type)"
            >
              <div class="md-list-text-container">
                <span>{{ structure.name }}</span>
                <p>{{ structure.description.slice(0,35) }}</p>
              </div>

              <md-button class="md-icon-button md-list-action">
                <md-icon
                  class="done"
                  v-if="structure.status === 1"
                >done</md-icon>
                <md-icon v-else>add_a_photo</md-icon>
              </md-button>

              <md-divider class="md-inset"></md-divider>
            </md-list-item>
          </md-list>

          <!-- <span class="md-caption">Fotografe as paredes e os pontos definidos na etapa anterior</span> -->
          <!-- <div class="planta">
            <svg preserveAspectRatio="xMinYMin meet " style="display:flex" :viewBox="`${area.x} ${area.y-2} ${parseInt(area.w,10)} ${parseInt(area.h,10)}`" :height="this.window.innerHeight-211" :width="this.window.innerWidth">
              <image x="0" y="0" :xlink:href="blueprint" :height="bpHeight" :width="bpWidth" />
              <rect :x="area.x+.5" :y="area.y-1.5" width="98.5%" height="100%" style="fill:#ff6f00;stroke:#f4511e;stroke-width:1;opacity:0.5"  fill-opacity="0.2"></rect>
              <svg :fill="item.status===1?'#3ccb70':'#00000'" height="10" viewBox="0 0 24 24" width="10" xmlns="http://www.w3.org/2000/svg" @click="addPhotos(key, item.type)" v-show="currPhotoType === 'vertices'" v-for="(item,key) in vertices" :key="item['.key']" :x="item.x" :y="item.y" >
                <circle cx="12" cy="12" r="3.2"  />
                <path d="M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z" />
              </svg>
            </svg>
            <structureCameraIcon @click.native="addPhotos(key, item.type)" v-for="(item, key) in structureList " v-show="currPhotoType === 'equipment'" :value="item " :data-key="key" :key="item[ '.key'] " style="position:absolute"></structureCameraIcon>
          </div> -->
          <md-layout md-column>
            <router-link
              tag="md-button"
              v-if="isAreaFinished"
              class="md-raised md-primary"
              to="/syncArea"
            >ENVIAR FOTOS E LIBERAR MEMÓRIA</router-link>
            <span
              class="caption"
              v-if="isAreaFinished"
            >*Este passo <b>não é obrigatório</b>, porém recomendado. Após a sincronização não será possível alterar as fotos desta área.</span>
          </md-layout>
        </div>
        <md-layout md-row>
          <md-layout md-column>
            <md-button class="md-accent md-dense" @click="prevArea(key)"
                       v-if="key !== 0">
              <span><md-icon class="md-accent">arrow_left</md-icon>ÁREA ANTERIOR</span>
            </md-button>
          </md-layout>
          <md-layout md-column>
            <md-button class="md-accent md-dense" @click="nextArea(key)"
                       v-if="certificationProcess.areas.length > 1 &&
                       key !== certificationProcess.areas.length -1"><span>PRÓXIMA ÁREA <md-icon class="md-accent">arrow_right</md-icon></span>
            </md-button>
          </md-layout>
        </md-layout>
      </md-tab>
    </md-tabs>
    <!-- <md-bottom-bar md-shift class="md-transparent bottom-bar-type">
      <md-bottom-bar-item md-icon="rounded_corner" :md-active="currPhotoType === 'vertices'" @click="changeActiveType('vertices')">Vertices</md-bottom-bar-item>
      <md-bottom-bar-item md-icon="kitchen" :md-active="currPhotoType === 'equipment'" @click="changeActiveType('equipment')">Equipamentos</md-bottom-bar-item>
    </md-bottom-bar> -->
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import StructureCameraIcon from '@/components/StructureCameraIcon'

export default {
  name: 'photos-view',
  components: {
    StructureCameraIcon
  },
  data: () => ({
    blueprint: '',
    bpHeight: 100,
    bpWidth: 100
  }),
  computed: {
    ...mapState({
      certificationProcess: state => state.certificationProcess,
      currPhotoType: state => state.currPhotoType,
      currPhotoArea: state => state.currPhotoArea
    }),
    vertices: function () {
      let vm = this
      if (!this.certificationProcess.areas) {
        return []
      } else {
        return this.certificationProcess.areas[vm.currPhotoArea].vertices
      }
    },
    structures: function () {
      let vm = this
      if (!this.certificationProcess.areas) {
        return []
      } else {
        if (!this.certificationProcess.areas[vm.currPhotoArea].structures) {
          return []
        }
        return this.certificationProcess.areas[vm.currPhotoArea].structures
      }
    },
    isAreaFinished: function () {
      var isFinished = true
      for (
        let v = 0;
        v < this.certificationProcess.areas[this.currPhotoArea].vertices.length;
        v++
      ) {
        const vertice = this.certificationProcess.areas[this.currPhotoArea]
          .vertices[v]
        if (vertice.status == null || vertice.status === 0) isFinished = false
      }

      if (this.certificationProcess.areas[this.currPhotoArea].structures) {
        for (
          let v = 0;
          v <
          this.certificationProcess.areas[this.currPhotoArea].structures.length;
          v++
        ) {
          const structure = this.certificationProcess.areas[this.currPhotoArea]
            .structures[v]
          if (structure.status == null || structure.status === 0) isFinished = false
        }
      }

      return isFinished
    }
  },
  beforeMount () {
    this.FETCH_DATA()
    // .then(() => {
    // this.bpHeight = this.certificationProcess.bpHeight
    // this.bpWidth = this.certificationProcess.bpWidth
    // this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imageBlob => {
    //   this.loadBlueprint(imageBlob)
    // })
    // })
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      // 'FETCH_IMAGE',
      'SET_AREA',
      'SET_PHOTO_TYPE',
      'SET_PHOTO_AREA'
    ]),
    changeActiveType (type) {
      this.SET_PHOTO_TYPE(type)
    },
    addPhotos (structureKey, type) {
      let vm = this
      this.$router.push({
        name: 'Camera',
        params: {
          area: vm.currPhotoArea,
          structureKey: structureKey,
          type: type
        }
      })
    },
    loadBlueprint (imageBlob) {
      var vm = this
      let fileReader = new FileReader()
      fileReader.onload = function (e) {
        vm.blueprint = e.target.result
      }
      fileReader.readAsDataURL(imageBlob)
    },
    isActiveArea (index) {
      return true
    },
    onAreaChangeDelegate (index) {
      if (index === this.currPhotoArea) {
        return
      }

      this.SET_PHOTO_AREA(index).then(() => {
        // this.currentAreaKey = index
        let currentArea = this.certificationProcess.areas[this.currPhotoArea]
        // Sometimes the user creates an area and dont specify any equipment, so we need to create the vertices here
        if (!currentArea.vertices || currentArea.vertices.length === 0) {
          this.$set(currentArea, 'vertices', [])
          let margem = 11
          // top left
          let v0 = {
            id: 0,
            x: currentArea.x,
            y: currentArea.y,
            photos: [
              {
                name: 'Chão',
                description: 'Fique em frente ao vértice e aponte para o chão',
                image: ''
              },
              {
                name: 'Teto',
                description: 'Fique em frente ao vértice e aponte para o teto',
                image: ''
              },
              {
                name: 'Vértice Oposto',
                description: 'Aponte para o vertice oposto',
                image: ''
              }
            ],
            type: 'vertice',
            name: 'Vértice Superior Esquerdo'
          }
          // top right
          let v1 = {
            id: 1,
            x: parseInt(currentArea.w, 10) + currentArea.x - margem,
            y: currentArea.y,
            photos: [
              {
                name: 'Chão',
                description: 'Fique em frente ao vértice e aponte para o chão',
                image: ''
              },
              {
                name: 'Teto',
                description: 'Fique em frente ao vértice e aponte para o teto',
                image: ''
              },
              {
                name: 'Vértice Oposto',
                description: 'Aponte para o vertice oposto',
                image: ''
              }
            ],
            type: 'vertice',
            name: 'Vértice Superior Direito'
          }
          // bottom right
          let v2 = {
            id: 2,
            x: parseInt(currentArea.w, 10) + currentArea.x - margem,
            y: parseInt(currentArea.h, 10) + currentArea.y - margem,
            photos: [
              {
                name: 'Chão',
                description: 'Fique em frente ao vértice e aponte para o chão',
                image: ''
              },
              {
                name: 'Teto',
                description: 'Fique em frente ao vértice e aponte para o teto',
                image: ''
              },
              {
                name: 'Vértice Oposto',
                description: 'Aponte para o vertice oposto',
                image: ''
              }
            ],
            type: 'vertice',
            name: 'Vértice Inferior Direito'
          }
          // bottom left
          let v3 = {
            id: 3,
            x: currentArea.x,
            y: parseInt(currentArea.h, 10) + currentArea.y - margem,
            photos: [
              {
                name: 'Chão',
                description: 'Fique em frente ao vértice e aponte para o chão',
                image: ''
              },
              {
                name: 'Teto',
                description: 'Fique em frente ao vértice e aponte para o teto',
                image: ''
              },
              {
                name: 'Vértice Oposto',
                description: 'Aponte para o vertice oposto',
                image: ''
              }
            ],
            type: 'vertice',
            name: 'Vértice Inferior Esquerdo'
          }

          currentArea.vertices.push(v0)
          currentArea.vertices.push(v1)
          currentArea.vertices.push(v2)
          currentArea.vertices.push(v3)

          this.SET_AREA({ area: currentArea, key: this.currPhotoArea })
        }
      })
    },
    nextArea(currentIndex) {
      this.SET_PHOTO_AREA(currentIndex + 1)
    },
    prevArea(currentIndex) {
      this.SET_PHOTO_AREA(currentIndex - 1)
    }
  }
}
</script>
<style scoped>
.planta {
  /* padding-top: 8px; */
  display: flex;
}

.bottom-bar-type {
  position: absolute;
  bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// PhotosView.vue?706ecb14